import { Link } from '@remix-run/react';
import { NavLinkTargetOptions } from '@tarslib/types/lib/publishedProject';
import React from 'react';

export function CustomLink(
  props: React.ComponentProps<typeof Link> & {
    disabled?: boolean;
    target?: React.HTMLAttributeAnchorTarget;
    disabledReturnChildren?: boolean;
    isSampleLink?: boolean;
    sampleName?: string;
  },
) {
  const {
    children,
    disabled,
    target,
    disabledReturnChildren = true,
    isSampleLink,
    sampleName,
    ...rest
  } = props;

  const newTarget = React.useMemo(() => {
    if (target === undefined) {
      return undefined;
    }
    if (target === NavLinkTargetOptions.SELF) {
      return '_self';
    }
    if (target === NavLinkTargetOptions.BLANK) {
      return '_blank';
    }

    return target;
  }, [target]);

  if (isSampleLink) {
    return <a href={String(rest.to)}>{sampleName}</a>;
  }
  if (disabledReturnChildren && (disabled || !rest.to)) {
    return children;
  }
  return (
    <Link {...rest} target={newTarget}>
      {children}
    </Link>
  );
}
